import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    questions: [],
    loading: false,
    error: null,
    quizzes: {
        examAttempts: [],
        practiceAttempts: []
    },
    fridayExamAttempts: [],
};

const assessmentSlice = createSlice({
    name: 'assessment',
    initialState,
    reducers: {
        setQuestions: (state, action) => {
            state.questions = action.payload;
        },
        setQuizzes: (state, action) => {
            state.quizzes = action.payload;
        },
        setFridayExamAttempts: (state, action) => {
            state.fridayExamAttempts = action.payload;
        },
    },
    extraReducers: (builder) => {
    },
});

export const {
    setQuestions,
    setQuizzes,
    setFridayExamAttempts
} = assessmentSlice.actions;

export default assessmentSlice.reducer;